import React, { useEffect, useState } from 'react';
import axios from 'axios';

const COST_META = {
  paid: { label: '💸 Você paga', badge: 'bg-amber-100 text-amber-800 border-amber-300' },
  free: { label: '🟢 Grátis', badge: 'bg-green-100 text-green-800 border-green-300' },
  legacy: { label: '↩️ Legado', badge: 'bg-gray-100 text-gray-600 border-gray-300' },
  inactive: { label: '⚪ Inativo', badge: 'bg-gray-100 text-gray-600 border-gray-300' },
};

const IntegrationsStatusCard = ({ API }) => {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = async () => {
    try {
      setLoading(true); setError('');
      const { data } = await axios.get(`${API}/admin/integrations-status`);
      setItems(data.integrations || []);
    } catch (e) {
      setError(e.response?.data?.detail || 'Falha ao carregar');
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const paidActive = (items || []).filter(i => i.cost === 'paid' && i.active);

  return (
    <div className="bg-white border-2 border-slate-300 rounded-lg p-4 mb-4" data-testid="integrations-status-card">
      <div className="flex items-center justify-between mb-1">
        <h4 className="font-bold text-slate-900 flex items-center gap-2">🔌 Integrações & Custos</h4>
        <button
          onClick={load}
          className="text-xs px-2 py-1 rounded border border-slate-300 hover:bg-slate-50"
          data-testid="integrations-refresh-btn"
        >
          {loading ? '⏳' : '🔄 Atualizar'}
        </button>
      </div>
      <p className="text-sm text-gray-600 mb-3">
        O que o app usa e o que <b>gera custo</b>. As chaves nunca são exibidas — só o status.
      </p>

      {paidActive.length > 0 && (
        <div className="mb-3 text-xs bg-amber-50 border border-amber-200 rounded p-2 text-amber-900" data-testid="integrations-paid-summary">
          Pagos ativos agora: <b>{paidActive.map(i => i.name.replace(/\s*\(.*\)/, '')).join(' · ')}</b>
        </div>
      )}

      {error && <div className="text-sm text-red-600" data-testid="integrations-error">{error}</div>}
      {loading && !items && <div className="text-sm text-gray-500">Carregando...</div>}

      <div className="space-y-2">
        {(items || []).map((i) => {
          const meta = COST_META[i.cost] || COST_META.inactive;
          return (
            <div key={i.id} className="flex items-start gap-3 border rounded-lg p-3" data-testid={`integration-${i.id}`}>
              <div className="text-2xl leading-none flex-shrink-0">{i.icon}</div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold text-slate-800">{i.name}</span>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded-full border ${meta.badge}`}>{meta.label}</span>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded-full border ${i.active ? 'bg-emerald-100 text-emerald-800 border-emerald-300' : 'bg-slate-100 text-slate-500 border-slate-300'}`}
                    data-testid={`integration-${i.id}-status`}
                  >
                    {i.active ? '● Ligado' : '○ Desligado'}
                  </span>
                </div>
                <p className="text-xs text-gray-600 mt-0.5">{i.desc}</p>
                {i.manage && i.manage !== '—' && (
                  <p className="text-[11px] text-gray-400 mt-0.5">Gerenciar: {i.manage}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IntegrationsStatusCard;
